import { useTranslation } from 'next-i18next';
import React from 'react';
import { Col, Grid as BaseGrid, Row } from 'react-styled-flexboxgrid';
import styled from 'styled-components';
import { default as BaseProContactIcon } from './ProContactIcon';
import { default as ContactForm } from './ContactForm';

const ProContactIcon = styled(BaseProContactIcon)`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 30px 0;
  position: relative;
  top: 75px;
  z-index: -1;
`;

const Container = styled(BaseGrid)`
  padding-right: 0;
  padding-left: 0;
  margin-top: 50px;
`;

const UserContact = props => {
  const { isTablet, proUser } = props;

  const { t } = useTranslation();

  return (
    <>
      <h3>{t('pro.actions.contact')}</h3>
      <Container>
        <Row>
          <Col xs={!isTablet ? 8 : 12}>
            <ContactForm isTablet={isTablet} proUser={proUser} />
          </Col>
          {!isTablet ? (
            <Col xs={4}>
              <ProContactIcon />
            </Col>
          ) : null}
        </Row>
      </Container>
    </>
  );
};

export default UserContact;
